module.exports = __webpack_public_path__ + "img/广州知识城广场四期超高层.7a026790.png";